import { render, staticRenderFns } from "./article_list_menu.vue?vue&type=template&id=6f235f44&scoped=true&"
import script from "./article_list_menu.vue?vue&type=script&lang=js&"
export * from "./article_list_menu.vue?vue&type=script&lang=js&"
import style0 from "./article_list_menu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./article_list_menu.vue?vue&type=style&index=1&id=6f235f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f235f44",
  null
  
)

export default component.exports